import userEvent from "@testing-library/user-event";
import React, { FC, useEffect, useState } from "react";
import { Accordion, Button, Card } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Element } from "../../../../models/elementModel";
import { Row } from "../../../../models/rowModel";
import { TabModel } from "../../../../models/tabModel";
import { getSession } from "../../../../selectors/appSelectors";
import { getAllRows } from "../../../../selectors/rowListSelector";
import { getCollapseByElementId } from "../../../../selectors/tabListSelector";
import RowElement from "../../RowElement";
import CollapseContent from "./CollapsContent";
import { Tooltip } from "react-tippy";


export interface RenderConllapsProps {
  index: string;
  element: Element;
  isPreview?: boolean;
}

const CollapsElement: FC<RenderConllapsProps> = ({
  index,
  element,
  isPreview = false,
}) => {
  const collapseList = useSelector(getCollapseByElementId(element.id));

  const sessionState = useSelector(getSession);
  const [viewRemark, setViewRemark] = useState(sessionState.viewRemark);
  const [open, setIsOpen] = useState(false);
  
  useEffect(() => {
    setViewRemark(sessionState.viewRemark)
    console.log(sessionState.viewRemark)

  }, [sessionState])
  
  const defaultStyle = {
    marginTop: element.properties.isMarginAll
      ? element.styles.margin + "px"
      : element.styles.marginTop + "px",
    marginRight: element.properties.isMarginAll
      ? element.styles.margin + "px"
      : element.styles.marginRight + "px",
    marginBottom: element.properties.isMarginAll
      ? element.styles.margin + "px"
      : element.styles.marginBottom + "px",
    marginLeft: element.properties.isMarginAll
      ? element.styles.margin + "px"
      : element.styles.marginLeft + "px",
    textAlign: element.styles.textAlign,
  };
  //custome css - start
  const styleList = element.properties.cssStyles;

  const styleObj: { [key: string]: any } = {};

  for (let index = 0; index < styleList.length; index++) {
    styleObj[styleList[index].retrivedStyle] = styleList[index].value;
  }
  //custome css - end

  return (
    <div key={index} style={{ ...defaultStyle }}>
      <Accordion
        id={element.id.toString()}
        className={`${
          element.properties.display === false ? "blur-element" : ""
        }`}
        style={{
          ...styleObj,
          width:
            element.styles.width == "" || element.styles.width == undefined
              ? ""
              : element.styles.width + "px",
        }}
      >
        {collapseList.map((card, i) => {
          if (isPreview && card.display === true) {
            return (
              <Card
                style={{ textAlign: element.styles.textAlign }}
                bg={element.properties.backgroundColor}
                text={element.properties.bodyFontColor}
              >
                <Card.Header>
                  <Accordion.Toggle
                    as={Button}
                    variant="link"
                    eventKey={`${card.id}`}
                    style={{
                      color: element.styles.color,
                      fontFamily: element.styles.fontFamily,
                      fontSize:
                        element.styles.fontSize === "" ||
                        element.styles.fontSize === undefined ||
                        element.styles.fontSize === "0"
                          ? ""
                          : element.styles.fontSize + "pt",
                    }}
                  >
                    {card.name}
                  </Accordion.Toggle>
                </Card.Header>
                <Accordion.Collapse eventKey={`${card.id}`}>
                  <CollapseContent
                    card={card}
                    index={i}
                    isPreview={isPreview}
                  />
                </Accordion.Collapse>
              </Card>
            );
          } else if (isPreview === false) {
            return (
              <Card
                style={{ textAlign: element.styles.textAlign }}
                bg={element.properties.backgroundColor}
                text={element.properties.bodyFontColor}
              >
                <Card.Header>
                  <Accordion.Toggle
                    as={Button}
                    variant="link"
                    eventKey={`${card.id}`}
                    className={`${card.display ? "" : "blur-element"}`}
                    style={{
                      color: element.styles.color,
                      fontFamily: element.styles.fontFamily,
                      fontSize:
                        element.styles.fontSize === "" ||
                        element.styles.fontSize === undefined ||
                        element.styles.fontSize === "0"
                          ? ""
                          : element.styles.fontSize + "px",
                    }}
                  >
                    {card.name}
                  </Accordion.Toggle>
                </Card.Header>
                <Accordion.Collapse eventKey={`${card.id}`}>
                  <CollapseContent
                    card={card}
                    index={i}
                    isPreview={isPreview}
                  />
                </Accordion.Collapse>
              </Card>
            );
          }
        })}
      </Accordion>
      {isPreview &&
        viewRemark &&
        (element.properties.remark1 ||
          element.properties.remark2 ||
          element.properties.remark3 ||
          element.properties.remark4) && (
          <Tooltip
            interactive
            open={open}
            onRequestClose={() => setIsOpen(false)}
            html={
              <>
                <h6>Remarks of {element.name}</h6>
                {element.properties.remark1 !== undefined &&
                  element.properties.remark1 !== "" && (
                    <div className="remark">
                      Remark 1 : {element.properties.remark1}
                    </div>
                  )}
                {element.properties.remark2 !== undefined &&
                  element.properties.remark2 !== "" && (
                    <div className="remark">
                      Remark 2 : {element.properties.remark2}
                    </div>
                  )}
                {element.properties.remark3 !== undefined &&
                  element.properties.remark3 !== "" && (
                    <div className="remark">
                      Remark 3 : {element.properties.remark3}
                    </div>
                  )}
                {element.properties.remark4 !== undefined &&
                  element.properties.remark4 !== "" && (
                    <div className="remark">
                      Remark 4 : {element.properties.remark4}
                    </div>
                  )}
                {(element.properties.remark1 === undefined ||
                  element.properties.remark1 === "") &&
                  (element.properties.remark2 === undefined ||
                    element.properties.remark2 === "") &&
                  (element.properties.remark3 === undefined ||
                    element.properties.remark3 === "") &&
                  (element.properties.remark4 === undefined ||
                    element.properties.remark4 === "") && (
                    <div>No Remarks to Display</div>
                  )}
              </>
            }
            position="left"
          >
            <div style={{ textAlign: "end" }}>
              <i
                className="fa fa-info-circle"
                aria-hidden="true"
                onClick={() => {
                  setIsOpen(true);
                }}
              ></i>
            </div>
          </Tooltip>
        )}
    </div>
  );
};

export default CollapsElement;
